import InputErrorMessage from "@mirage/components/inputErrorMessage/InputErrorMessage";
import PasswordPopper from "@mirage/components/passwordPopper/PasswordPopper";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import React from "react";
import { RegisterInputData, RegistrationFieldReferences } from "./PublicRegister";

interface FirstStepFieldsProps {
    emailData: RegisterInputData;
    passwordData: RegisterInputData;
    passwordConfirmData: RegisterInputData;
    onChangeHandler: (value: string, inputReference: RegistrationFieldReferences) => void;
    onBlurHandler: (inputReference: RegistrationFieldReferences) => void;
    showPasswordHandler: (inputReference: "password" | "passwordConfirm") => void;
}

const FirstStepFields: React.FC<FirstStepFieldsProps> = ({ emailData, passwordData, passwordConfirmData, onChangeHandler, onBlurHandler, showPasswordHandler }): JSX.Element => {
    const [passwordPopperAnchorElement, setPasswordPopperAnchorElement] = React.useState<null | HTMLElement>(null);
    const [passwordPopperVisibility, setPasswordPopperVisibility] = React.useState(false);

    const getPassFieldsEndAdornment = (fieldRef: "password" | "passwordConfirm") => {
        const showPassword = fieldRef === "password" ? passwordData.showPassword : passwordConfirmData.showPassword;
        return (
            <InputAdornment position="end">
                <IconButton onClick={() => showPasswordHandler(fieldRef)} onMouseDown={(e) => e.preventDefault()}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </InputAdornment>
        );
    };

    return (
        <>
            <TextField
                sx={{ width: "60%" }}
                required={true}
                id="register-email"
                error={!emailData.validationResult.passed}
                value={emailData.value}
                helperText={<InputErrorMessage passed={emailData.validationResult.passed} message={emailData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "email")}
                onBlur={() => onBlurHandler("email")}
                label="Email"
                variant="outlined"
            />
            {passwordPopperVisibility && passwordPopperAnchorElement && passwordData.validationResult.conditions ? (
                <PasswordPopper anchorElement={passwordPopperAnchorElement} conditions={passwordData.validationResult.conditions}></PasswordPopper>
            ) : (
                ""
            )}
            <TextField
                sx={{ width: "60%" }}
                required={true}
                id="register-password"
                error={!passwordData.validationResult.passed}
                defaultValue={passwordData.value}
                helperText={
                    passwordData.validationResult.error === "Password should not be longer than 55 characters" ? (
                        <InputErrorMessage passed={passwordData.validationResult.passed} message={passwordData.validationResult.error} />
                    ) : (
                        ""
                    )
                }
                type={passwordData.showPassword ? "text" : passwordData.type}
                InputProps={{ endAdornment: getPassFieldsEndAdornment("password") }}
                onBlur={() => setPasswordPopperVisibility(false)}
                onChange={(e) => onChangeHandler(e.target.value, "password")}
                onFocus={(e) => {
                    onBlurHandler("password");
                    const inputContainer = e.currentTarget.parentElement;

                    if (!passwordPopperAnchorElement) {
                        setPasswordPopperAnchorElement(inputContainer);
                    }
                    if (!passwordPopperVisibility) {
                        setPasswordPopperVisibility(true);
                    }
                }}
                label="Password"
                variant="outlined"
            />
            <TextField
                sx={{ width: "60%" }}
                required={true}
                id="register-passwordConfirm"
                error={!passwordConfirmData.validationResult.passed}
                defaultValue={passwordConfirmData.value}
                type={passwordConfirmData.showPassword ? "text" : passwordConfirmData.type}
                helperText={<InputErrorMessage passed={passwordConfirmData.validationResult.passed} message={passwordConfirmData.validationResult.error} />}
                InputProps={{ endAdornment: getPassFieldsEndAdornment("passwordConfirm") }}
                onChange={(e) => onChangeHandler(e.target.value, "passwordConfirm")}
                onBlur={() => onBlurHandler("passwordConfirm")}
                label="Password Confirm"
                variant="outlined"
            />
        </>
    );
};

export default FirstStepFields;
